import React from "react";
import ToolTip from "../../../../parts/tooltip-portal";
import { S3 } from "../../../../constants";

class ImageSelector extends React.Component {
  constructor(props) {
    super(props);
    this.fileInput = null;
    this.setFileInputRef = (element) => {
      this.fileInput = element;
    };
    this.state = {
      backgroundImage: null,
      imageValue: null,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleBackgroundImage = this.handleBackgroundImage.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.updateBackground = this.updateBackground.bind(this);
  }

  updateBackground(imageObject = null) {
    const value = imageObject ? imageObject : this.props.value;
    if (!value) return;
    if (!value.s3Path) return;

    const backgroundImage = `${S3.PATH}${value.s3Path}`;

    this.setState({
      backgroundImage,
      imageValue: value,
    });
  }

  componentDidMount() {
    this.updateBackground();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.updateBackground(nextProps.value);
    }
  }

  handleClick() {
    if (this.fileInput) this.fileInput.click();
  }

  handleBackgroundImage(backgroundImage) {
    this.setState({ backgroundImage });
  }

  handleInput({ target }) {
    const { onChange = () => {} } = this.props;

    const reader = new FileReader();

    reader.addEventListener("load", () => {
      const uploaded_image = reader.result;
      const backgroundImage = uploaded_image;
      this.handleBackgroundImage(backgroundImage);
      onChange({ target, backgroundImage });
    });

    if (target && target.files && target.files[0] instanceof Blob) {
      reader.readAsDataURL(target.files[0]);
    }
  }

  render() {
    const {
      title = "",
      id = "",
      buttonTitle = "",
      info = "",
      subInfo = "",
      toolTipTextBody,
      forOnboarding = false,
      imageDimensions = {
        marginTop: "20px",
      },
      additionalStyle = {},
      imageInputs = [],
      inputName = "",
      fullWidth = false,
      fullHeight = false,
      additionalContent = <div></div>,
      noInfo = false,
      showButton = true,
      blackBg = false,
      selectorTitle = "",
      mobile = false,
      classNames = "",
      allowedExtensions = "image/*",
    } = this.props;

    const { backgroundImage, imageValue } = this.state;

    return (
      <div
        className={`image-selector${blackBg ? " black-bg" : ""} ${classNames}`}
        style={
          fullWidth && fullHeight
            ? {
                width: "unset",
                height: "100%",
              }
            : fullWidth
            ? {
                width: "unset",
              }
            : fullHeight
            ? {
                height: "100%",
              }
            : {}
        }
      >
        {imageInputs.map((inputProps, idx) => {
          return (
            <input
              key={idx}
              type="hidden"
              name={inputProps.name}
              value={inputProps.value}
            />
          );
        })}
        <div>
          <div className="title-row">
            {title && <span className="font-bold">{title}</span>}
            {toolTipTextBody && (
              <ToolTip body={toolTipTextBody} forOnboarding={forOnboarding}>
                <img className="help-icon" src="/img/svg/question-circle.svg" />
              </ToolTip>
            )}
          </div>
          <input
            ref={this.setFileInputRef}
            type="file"
            accept={allowedExtensions}
            name={inputName}
            id={`upload-${id}`}
            hidden
            onChange={this.handleInput}
            defaultValue={imageValue}
          />
          <div
            className="image-section"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <label
              className={`image-container${
                backgroundImage ? " dimensions-fixed" : ""
              }`}
              style={Object.assign(
                {},
                imageDimensions,
                {
                  ...(!mobile && {
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }),
                },
                additionalStyle
              )}
              htmlFor={`upload-${id}`}
            >
              {!backgroundImage ? (
                <>
                  {selectorTitle ? (
                    <span className="selector-title">{selectorTitle}</span>
                  ) : null}
                  <picture className="placeholder">
                    <img
                      src="/img/new-icons/add-square-outline.svg"
                      alt="add"
                    />
                  </picture>
                  {!noInfo ? <span>{subInfo}</span> : null}
                </>
              ) : mobile ? (
                <picture className="selected-image">
                  <img src={backgroundImage} alt="add" />
                </picture>
              ) : null}
            </label>
          </div>
        </div>
        {additionalContent ? additionalContent : null}
        {showButton ? (
          <div className="edit-button" onClick={this.handleClick}>
            <span>{buttonTitle}</span>
            <img alt="edit" src="/img/new-icons/upload-file.svg" />
          </div>
        ) : null}
      </div>
    );
  }
}

export default ImageSelector;
